/**
 * "Welcome, Vesile" — first name from a display name.
 *
 * Clever-provisioned teachers carry displayName = "First Last" (no separate
 * first/last fields on users/{uid}); Google accounts the same. The first
 * whitespace token is the name; anything containing "@" is an email fallback
 * and yields null so the tour shows the plain title instead.
 */
export function firstNameFrom(displayName) {
  const s = typeof displayName === 'string' ? displayName.trim() : '';
  if (!s || s.includes('@')) return null;
  const first = s.split(/\s+/)[0];
  return first || null;
}
